import { gtcVideoAutoplay } from "gtcUtils";

class VideoAutoplay extends gtcVideoAutoplay {
    // Add any initialization code here
    constructor() {
        super();
    }
}

if (!window.customElements.get('video-autoplay')) {
    customElements.define('video-autoplay', VideoAutoplay);
}
